import { Inject, Injectable } from '@angular/core';
import { NavBarItem, NavBarItemBase } from '@core/config';
import { MwPerfectScrollBarDirective } from '@core/directives/perfect-scrollbar.directive';
import { MW_MENU_ITEMS } from '@core/injection-tokens';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MwLayoutService {
  layoutScrollBar: MwPerfectScrollBarDirective;
  private navBarItems: NavBarItem[] = [];
  readonly changeNavBarItems$: BehaviorSubject<NavBarItem[]>;

  constructor(@Inject(MW_MENU_ITEMS) menuItems: NavBarItemBase[]) {
    const items = menuItems.map((t) => new NavBarItem(t));
    this.changeNavBarItems$ = new BehaviorSubject(items);
  }

  setLayoutScrollBar(scrollBar: MwPerfectScrollBarDirective): void {
    this.layoutScrollBar = scrollBar;
  }

  setNavBarItems(items: NavBarItem[]): void {
    this.navBarItems = items;
  }

  getNavBarItem(id: string): NavBarItem {
    return this.navBarItems.find((t) => t.id === id);
  }

  changeNavBarItem(id: string, newItem: NavBarItem): void {
    const index = this.navBarItems.findIndex((t) => t.id === id);
    const items = this.navBarItems.map((item, itemIndex) =>
      index === itemIndex ? newItem : item
    );
    this.changeNavBarItems$.next(items);
  }

  changeNavBarItems(items: NavBarItem[]): void {
    this.changeNavBarItems$.next(items);
  }
}
